import styled from "styled-components"
import { Input } from "antd"

const InputStyled = styled(Input)`
  width: ${(props) => props.width};
`

export default InputStyled
